import * as React from "react"
const SvgTrendingDown = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m18.6 16-5.2-5.15-2.575 2.575Q10.25 14 9.4 14t-1.425-.575L2.7 8.1a.98.98 0 0 1-.288-.687A.93.93 0 0 1 2.7 6.7a.95.95 0 0 1 .7-.275q.425 0 .7.275L9.4 12l2.575-2.575q.575-.575 1.425-.575t1.425.575L20 14.6V13q0-.424.288-.713A.97.97 0 0 1 21 12q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712A.97.97 0 0 1 21 18h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 16 17q0-.424.288-.712A.97.97 0 0 1 17 16z" />
  </svg>
)
export default SvgTrendingDown
